// CacheKey 53f8baf22455e9426bfe2e61054b524e
//
// DO NOT MODIFY: This file was automatically generated by JsFromTranslations.
export default {
  "en-ACCOUNT_STRATEGY": {
    models: {
      captain: "advisor",
      Captain: "Advisor",
      encounter: "product",
      Encounter: "Product",
      encounters: "products",
      Encounters: "Products",
      patient: "account",
      Patient: "Account",
      patients: "accounts",
      Patients: "Accounts"
    },
    exports: {
      defaults: {
        encounter: {
          id: "Product ID",
          status: "Product Status"
        }
      }
    },
    ribbon: {
      encounters: "Products"
    },
    admitted_patients: {
      title: "Admitted Accounts"
    },
    monitored_patients: {
      title: "Monitored Accounts"
    },
    my_patient_panel: {
      title: "My Account Panel"
    },
    patients_search: {
      nav_menu: "Accounts"
    },
    plans: {
      patient_information: "Account Info"
    }
  }
}

